
export class ReservationsStatisticsModel {
  constructor (
    public canceledReservations?: number,
    public declinedReservations?: number,
    public pastReservations?: number,
    public upcomingReservations?: number,
    public totalReservations?: number,
  ) {}
}
